let env = process.env.NODE_ENV === 'development' ? 'development' : process.env.VUE_APP_TITLE;
// const baseUrlTest = "http://wlguanwang.dhclgl.com/";
const baseUrlTest = "https://api.dhwljt.cn/";
const baseUrlProd = "https://api.dhwljt.cn/";
const baseUrl = (env === 'development' || env === 'build_dev') ? baseUrlTest : baseUrlProd;
export default {
	baseUrl: `${baseUrl}`,
	projectName: "敦煌文旅集团官网",
	homeNav: `${baseUrl}api/category/all`,
	getBannerList: `${baseUrl}api/banner?category_id=`,
	geHomeData: `${baseUrl}api/index`,
	getListData: `${baseUrl}api/index/lists?category_id=`,
	getDetailData: `${baseUrl}api/details?id=`,
	getOrganizationDetailData: `${baseUrl}api/organ/details?id=`,
	getTimesDetailData: `${baseUrl}api/index/times?category_id=`,
};